import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PaymentReceiptView } from "./PaymentReceiptView";
import { PaymentReceiptViewStore } from "../../store/PaymentReceiptViewStore";
import { useStore } from "../../../../hooks";

export const PaymentReceiptViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/paymentReceipt/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PaymentReceiptViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PaymentReceiptView paymentReceiptViewStore={store} />
      </PageLayout>
    </div>
  );
});
